/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompanyWizardStepStateResource } from './';
import {
    ClientCompanyWizardStepStateResourceFromJSON,
    ClientCompanyWizardStepStateResourceFromJSONTyped,
    ClientCompanyWizardStepStateResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanySettingsContextResource
 */
export interface ClientCompanySettingsContextResource {
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    profileStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    legalStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    ssoStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    walletStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    proposalSettingsStepSate?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    projectSettingsStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    paymentPreferencesStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    activityTrackerPreferencesStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {ClientCompanyWizardStepStateResource}
     * @memberof ClientCompanySettingsContextResource
     */
    serviceLevelStepState?: ClientCompanyWizardStepStateResource;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof ClientCompanySettingsContextResource
     */
    availableCountries?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof ClientCompanySettingsContextResource
     */
    blackListedCountries?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCompanySettingsContextResource
     */
    availableCurrencies?: Array<string>;
}

/**
 * Check if a given object implements the ClientCompanySettingsContextResource interface.
 */
export function instanceOfClientCompanySettingsContextResource(value: object): value is ClientCompanySettingsContextResource {
    return true;
}

export function ClientCompanySettingsContextResourceFromJSON(json: any): ClientCompanySettingsContextResource {
    return ClientCompanySettingsContextResourceFromJSONTyped(json, false);
}

export function ClientCompanySettingsContextResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanySettingsContextResource {
    if (json == null) {
        return json;
    }
    return {
        
        'profileStepState': json['profileStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['profileStepState']),
        'legalStepState': json['legalStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['legalStepState']),
        'ssoStepState': json['ssoStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['ssoStepState']),
        'walletStepState': json['walletStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['walletStepState']),
        'proposalSettingsStepSate': json['proposalSettingsStepSate'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['proposalSettingsStepSate']),
        'projectSettingsStepState': json['projectSettingsStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['projectSettingsStepState']),
        'paymentPreferencesStepState': json['paymentPreferencesStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['paymentPreferencesStepState']),
        'activityTrackerPreferencesStepState': json['activityTrackerPreferencesStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['activityTrackerPreferencesStepState']),
        'serviceLevelStepState': json['serviceLevelStepState'] == null ? undefined : ClientCompanyWizardStepStateResourceFromJSON(json['serviceLevelStepState']),
        'availableCountries': json['availableCountries'] == null ? undefined : json['availableCountries'],
        'blackListedCountries': json['blackListedCountries'] == null ? undefined : json['blackListedCountries'],
        'availableCurrencies': json['availableCurrencies'] == null ? undefined : json['availableCurrencies'],
    };
}

export function ClientCompanySettingsContextResourceToJSON(value?: ClientCompanySettingsContextResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileStepState': ClientCompanyWizardStepStateResourceToJSON(value['profileStepState']),
        'legalStepState': ClientCompanyWizardStepStateResourceToJSON(value['legalStepState']),
        'ssoStepState': ClientCompanyWizardStepStateResourceToJSON(value['ssoStepState']),
        'walletStepState': ClientCompanyWizardStepStateResourceToJSON(value['walletStepState']),
        'proposalSettingsStepSate': ClientCompanyWizardStepStateResourceToJSON(value['proposalSettingsStepSate']),
        'projectSettingsStepState': ClientCompanyWizardStepStateResourceToJSON(value['projectSettingsStepState']),
        'paymentPreferencesStepState': ClientCompanyWizardStepStateResourceToJSON(value['paymentPreferencesStepState']),
        'activityTrackerPreferencesStepState': ClientCompanyWizardStepStateResourceToJSON(value['activityTrackerPreferencesStepState']),
        'serviceLevelStepState': ClientCompanyWizardStepStateResourceToJSON(value['serviceLevelStepState']),
        'availableCountries': value['availableCountries'],
        'blackListedCountries': value['blackListedCountries'],
        'availableCurrencies': value['availableCurrencies'],
    };
}

